import { CompanyAPI } from '@api';

const getFinancialPenaltiesByMechanicalFailureFromLastWeek = async () => CompanyAPI
  .getFinancialPenaltiesByMechanicalFailureFromLastWeek()
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { getFinancialPenaltiesByMechanicalFailureFromLastWeek };
